import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import CloseSubmitBtn from "../custom-comps/CloseSubmitBtn";
import {
  extractVariableKeys,
  validateCommonBroadForm,
} from "../../broadcast-system/Validations";
import { commonPostPutApi, fetchApiDataDup3 } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import ReactQuillTextEditor from "../../components-react/inputs/ReactQuillTextEditor";
import Loader from "../../ui/Loader";
import {
  fetchBroadcastTemplatesData,
  fetchBroadcastVariablesData,
  fetchBroadcastWPTemplatesData,
} from "../../../redux/ad-blog-reducers/blogSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import TemplateForm from "../../broadcast-system/templates/email-template/TemplateForm";
import VariableForm from "../../broadcast-system/variables/VariableForm";
import ReviewTemplateForm from "./ReviewTemplateForm";
import BroadcastProgressBar from "./BroadcastProgressBar";
import { wati_accounts } from "../../common-data/DropdowData";
import { sendyListVerify } from "../../../data/ApiEndpoints";

const BroadcastCampaignForm = ({
  userInfoData,
  closeModal,
  handleBack,
  selectedMembers,
  from,
  callFunction,
  allFilters,
  selectedRecipient,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    broadcastTemplates,
    broadcastTemplatesLoading,
    broadcastTemplatesError,

    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,

    broadcastVariables,
    broadcastVariablesLoading,
    broadcastVariablesError,
  } = useSelector((state) => state.blog);

  const forminitials = {
    broadcastName: "",

    subjectName: "",
    isEmail: false,
    isWhatsaap: false,
    isPush: false,

    // Email provider selection
    emailProvider: "", // "brevo" or "sendy"

    selectedEmailTemplate: "",
    selectedWPTemplate: "",
    selectedWhatsappAccount: "",
    selectedEmailTemplateVariables: {},
    selectedWPTemplateVariables: {},
    selectedPushTemplateVariables: {},

    pushTitle: "",
    pushBody: "",
  };

  // Sendy list verification state
  const [sendyListId, setSendyListId] = useState("");
  const [sendyVerifying, setSendyVerifying] = useState(false);
  const [sendyVerified, setSendyVerified] = useState(false);
  const [sendyListName, setSendyListName] = useState("");
  const [sendyError, setSendyError] = useState("");
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [wpTemplates, setWpTemplates] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [variables, setVariables] = useState([]);
  const [emailVariableKeys, setEmailVariableKeys] = useState([]);
  const [whatsappVariableKeys, setWhatsappVariableKeys] = useState([]);
  const [pushVariableKeys, setPushVariableKeys] = useState([]);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const [isReviewAndSubmit, setIsReviewAndSubmit] = useState(false);
  const [showProgress, setShowProgress] = useState(false);

  const handleProgressComplete = () => {
    setTimeout(() => {
      setShowProgress(false);
      // closeModal();
    }, 2000);
  };

  const handleCloseProgress = () => {
    setShowProgress(false);
    closeModal();
  };

  // --------------- GET DATA ---------------
  const getWPTemplates = (filters) => {
    dispatch(
      fetchBroadcastWPTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getEmailTemplates = (filters) => {
    dispatch(
      fetchBroadcastTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getVariables = (filters) => {
    dispatch(
      fetchBroadcastVariablesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };
  // ------------------ END GET DATA ------------------

  // Sendy list verification
  const verifySendyList = async () => {
    if (!sendyListId.trim()) {
      setSendyError("Please enter a list ID");
      return;
    }

    setSendyVerifying(true);
    setSendyError("");
    setSendyVerified(false);
    setSendyListName("");

    try {
      const result = await dispatch(
        fetchApiDataDup3({
          method: "GET",
          endpoint: sendyListVerify,
          payload: {
            filters: {
              list_id: sendyListId,
            },
          },
          token: userInfoData?.token,
        })
      );

      const data = result?.payload;

      if (data?.status && data?.data?.is_valid_list) {
        setSendyVerified(true);
        setSendyListName(data?.data?.list_name || "");
        setSendyError("");
        toast.success(`List verified: ${data?.data?.list_name}`);
      } else {
        setSendyVerified(false);
        setSendyError("List not found");
        toast.error("List not found");
      }
    } catch (error) {
      console.error("Error verifying Sendy list:", error);
      setSendyVerified(false);
      setSendyError("Failed to verify list");
      toast.error("Failed to verify list");
    } finally {
      setSendyVerifying(false);
    }
  };

  // Reset sendy state when email provider changes
  const handleEmailProviderChange = (provider) => {
    setFormValues((prev) => ({
      ...prev,
      emailProvider: prev.emailProvider === provider ? "" : provider,
    }));
    // Reset sendy verification when switching providers
    if (provider === "brevo") {
      setSendyListId("");
      setSendyVerified(false);
      setSendyListName("");
      setSendyError("");
    }
  };

  const handleBackStep = () => {
    setIsReviewAndSubmit(false);
    setIsSubmit(false);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    if (name === "pushTitle" || name === "pushBody") {
      const newTitle = name === "pushTitle" ? value : formValues.pushTitle;
      const newBody = name === "pushBody" ? value : formValues.pushBody;
      const combined = `${newTitle} ${newBody}`;
      const keys = extractVariableKeys(combined);
      setPushVariableKeys(keys);

      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedEmailTemplate") {
      let keys = [];
      if (value?.info?.body) {
        keys = extractVariableKeys(value.info.body);
      }
      setEmailVariableKeys(keys);

      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedEmailTemplateVariables: {},
      }));
      return;
    } else if (name === "selectedWPTemplate") {
      let keys = [];
      if (value?.info?.body) {
        keys = extractVariableKeys(value.info.body);
      }
      setWhatsappVariableKeys(keys);

      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedWPTemplateVariables: {},
      }));
      return;
    } else if (name === "selectedWhatsappAccount") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedWPTemplate: "",
        selectedWPTemplateVariables: {},
      }));
      setWpTemplates([]);
      setWhatsappVariableKeys([]);
      return;
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmitForm = async (payload) => {
    try {
      const method = "POST";
      const endpoint = "/wati/broadcast";
      const token = userInfoData?.token || "";

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);

        // closeModal();
        // handleBack();
        callFunction?.();
        setIsReviewAndSubmit(false);
        // toast.success(
        //   result?.payload?.message || "Template initiated successfully!"
        // );
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing template:", error);
      toast.error("Failed to process template");
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setIsSubmit(false);

    const errors = validateCommonBroadForm(
      formValues,
      emailVariableKeys,
      pushVariableKeys,
      whatsappVariableKeys
    );

    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      setIsReviewAndSubmit(true);
    } else {
      toast.error("Please fill all the required fields");
    }
  };

  useEffect(() => {
    if (formValues.isEmail || formValues.isWhatsaap) {
      const sendableFilters = {
        page: 1,
        limit: 3000,
        status: "active",
      };

      getVariables(sendableFilters);
    }
  }, [formValues.isEmail, formValues.isWhatsaap]);

  useEffect(() => {
    if (formValues.isEmail) {
      const sendableEmailTemplateFilters = {
        page: 1,
        limit: 3000,
        status: "active",
      };

      getEmailTemplates(sendableEmailTemplateFilters);
    }
  }, [formValues.isEmail]);

  useEffect(() => {
    if (formValues.isWhatsaap && formValues.selectedWhatsappAccount?.value) {
      const sendableWPTemplateFilters = {
        page: 1,
        limit: 3000,
        status: "APPROVED",
        whatsapp_account: formValues.selectedWhatsappAccount.value,
      };

      getWPTemplates(sendableWPTemplateFilters);
    }
  }, [formValues.isWhatsaap, formValues.selectedWhatsappAccount]);

  useEffect(() => {
    if (
      !broadcastTemplatesLoading &&
      !broadcastTemplatesError &&
      broadcastTemplates?.status &&
      broadcastTemplates?.data?.length > 0
    ) {
      const dropdownOptions = broadcastTemplates.data.map((item) => ({
        label: item.template_name?.replace(/_/g, " "),
        value: item.template_name,
        info: item,
      }));

      setEmailTemplates(dropdownOptions);
    } else {
      setEmailTemplates([]);
    }
  }, [broadcastTemplates, broadcastTemplatesLoading, broadcastTemplatesError]);

  useEffect(() => {
    if (
      !broadcastWPTemplatesLoading &&
      !broadcastWPTemplatesError &&
      broadcastWPTemplates?.status &&
      broadcastWPTemplates?.data?.length > 0
    ) {
      const dropdownOptions = broadcastWPTemplates.data.map((item) => ({
        label: item.elementName?.replace(/_/g, " "),
        value: item.elementName,
        info: item,
      }));

      setWpTemplates(dropdownOptions);
    } else {
      setWpTemplates([]);
    }
  }, [
    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,
  ]);

  useEffect(() => {
    if (
      !broadcastVariablesLoading &&
      !broadcastVariablesError &&
      broadcastVariables?.status &&
      broadcastVariables?.data?.length > 0
    ) {
      const dropdownOptions = broadcastVariables.data.map((item) => ({
        label: item.value?.replace(/_/g, " "),
        value: item.uid,
        info: item,
      }));

      setVariables(dropdownOptions);
    } else {
      setVariables([]);
    }
  }, [broadcastVariables, broadcastVariablesLoading, broadcastVariablesError]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const variables_email = emailVariableKeys.map((key) => ({
        key,
        variableId: formValues.selectedEmailTemplateVariables[key],
      }));

      const variables_whatsapp = formValues.isWhatsaap
        ? whatsappVariableKeys.map((key) => ({
            key,
            variableId: formValues.selectedWPTemplateVariables[key],
          }))
        : [];

      const variables_push = formValues.isPush
        ? pushVariableKeys.map((key) => ({
            key,
            variableId: formValues.selectedPushTemplateVariables[key],
          }))
        : [];

      const user_uids = selectedMembers?.length
        ? selectedMembers
            .map((member) => member?.value)
            .filter((id) => id && id !== "" && id !== null && id !== undefined)
        : [];

      const userData = {
        channel: [
          formValues.isWhatsaap && "whatsapp",
          formValues.isPush && "push",
          formValues.isEmail && "email",
        ]
          .filter(Boolean)
          .join(", "),

        broadcast_name: formValues.broadcastName || "",

        subject: formValues.subjectName || "",

        template_name_email: formValues.selectedEmailTemplate?.value || "",
        template_name_whatsapp: formValues.isWhatsaap
          ? formValues.selectedWPTemplate?.value || ""
          : "",
        template_name_push: formValues.isPush ? formValues.pushTitle || "" : "",

        variables_email,
        variables_whatsapp,
        variables_push,

        user_uids,
        user_type:
          from === "wati"
            ? "wati"
            : from === "recurring"
            ? "recurring"
            : from === "lms"
            ? "lead"
            : from === "odm"
            ? "odm"
            : from === "custom"
            ? selectedRecipient
            : "member",
        is_all_users: false,

        title_push: formValues.isPush ? formValues.pushTitle || "" : "",
        body_push: formValues.isPush ? formValues.pushBody || "" : "",
        template_whatsapp_body: formValues.isWhatsaap
          ? formValues.selectedWPTemplate?.info?.body || ""
          : "",
        whatsapp_account: formValues.isWhatsaap
          ? formValues.selectedWhatsappAccount?.value || ""
          : "",
        // Email provider fields
        list_type: formValues.isEmail ? formValues.emailProvider || "" : "",
        list_id: formValues.isEmail && formValues.emailProvider === "sendy"
          ? sendyListId
          : "",
      };

      const handleConfirm = async () => {
        setShowProgress(true);

        setTimeout(() => {
          handleSubmitForm(userData);
        }, 1000);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to broadcast this message?`,
        "Cancel",
        "Broadcast"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=>", formErrors);

  return (
    <>
      {showProgress ? (
        <BroadcastProgressBar
          isVisible={showProgress}
          onComplete={handleProgressComplete}
          onClose={handleCloseProgress}
          broadcastData={formValues}
          onModalClose={() => {}}
        />
      ) : (
        <>
          <Modal
            isOpen={modValues.isModOpen}
            onRequestClose={onCloseModal}
            contentLabel="Detail Modal"
            ariaHideApp={false}
          >
            <div className="createNewCTOModalContainer mod-width-50p">
              {modValues.modName !== "add-variable" && (
                <ModalHeadAndClose
                  title={
                    modValues.modName === "add-template"
                      ? `Create New Template`
                      : "Template Details"
                  }
                  onClose={onCloseModal}
                />
              )}

              {modValues.modName === "add-template" ? (
                <TemplateForm
                  closeModal={onCloseModal}
                  userInfoData={userInfoData}
                  callFunction={() => {
                    const sendableEmailTemplateFilters = {
                      page: 1,
                      limit: 3000,
                      status: "active",
                    };

                    getEmailTemplates(sendableEmailTemplateFilters);
                  }}
                />
              ) : modValues.modName === "add-variable" ? (
                <VariableForm
                  closeModal={onCloseModal}
                  userInfoData={userInfoData}
                  callFunction={() => {
                    const sendableFilters = {
                      page: 1,
                      limit: 3000,
                      status: "active",
                    };

                    getVariables(sendableFilters);
                  }}
                />
              ) : null}
            </div>
          </Modal>

          {isReviewAndSubmit ? (
            <ReviewTemplateForm
              allFilters={allFilters}
              selectedMembers={selectedMembers}
              formValues={formValues}
              handleBack={handleBackStep}
              variables={variables}
              // handleSubmitFormOnNextClick={() => setIsSubmit(true)}
              handleSubmitFormOnNextClick={() => {
                setIsSubmit(true);
              }}
            />
          ) : (
            <>
              <div className="formInputsGrid threeGridSystem mt15">
                <div className="formInputBox">
                  <label htmlFor="broadcastName" className={`formInputLabel`}>
                    broadcast name <span className="required">*</span>
                  </label>

                  <input
                    type="text"
                    placeholder="Enter broadcast name"
                    className={`formInput ${
                      formErrors?.broadcastName ? "formError" : ""
                    }`}
                    name="broadcastName"
                    value={formValues.broadcastName}
                    onChange={onChangeInput}
                  />
                </div>

                <div className="formInputBox checkbox-wrapper span3">
                  <div className="flex-box">
                    <label
                      className={`checkboxLabel ${
                        formErrors?.isWhatsaap ? "formError" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="isWhatsaap"
                        checked={formValues.isWhatsaap}
                        onChange={onChangeInput}
                      />
                      whatsapp broadcast
                    </label>

                    <label
                      className={`checkboxLabel ${
                        formErrors?.isEmail ? "formError" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="isEmail"
                        checked={formValues.isEmail}
                        onChange={onChangeInput}
                      />
                      email broadcast
                    </label>

                    <label
                      className={`checkboxLabel ${
                        formErrors?.isPush ? "formError" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="isPush"
                        checked={formValues.isPush}
                        onChange={onChangeInput}
                      />
                      push broadcast
                    </label>
                  </div>
                </div>
              </div>

              {formValues.isEmail && (
                <div className="section-details span3">
                  <div className="section-head">
                    <h3>Email Provider</h3>
                  </div>

                  <div className="formInputsGrid threeGridSystem">
                    <div className="formInputBox span3">
                      <label className="formInputLabel">
                        Select Email Provider <span className="required">*</span>
                      </label>

                      <div className="flex-box" style={{ gap: "20px", marginTop: "10px" }}>
                        <label
                          className={`checkboxLabel ${
                            formErrors?.emailProvider ? "formError" : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={formValues.emailProvider === "brevo"}
                            onChange={() => handleEmailProviderChange("brevo")}
                          />
                          Brevo
                        </label>

                        <label
                          className={`checkboxLabel ${
                            formErrors?.emailProvider ? "formError" : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={formValues.emailProvider === "sendy"}
                            onChange={() => handleEmailProviderChange("sendy")}
                          />
                          Sendy
                        </label>
                      </div>
                    </div>

                    {formValues.emailProvider === "sendy" && (
                      <div className="formInputBox span3">
                        <label htmlFor="sendyListId" className="formInputLabel">
                          Sendy List ID <span className="required">*</span>
                        </label>

                        <div className="flexBetween" style={{ gap: "10px" }}>
                          <input
                            type="text"
                            placeholder="Enter Sendy List ID"
                            className={`formInput ${sendyError ? "formError" : ""}`}
                            value={sendyListId}
                            onChange={(e) => {
                              setSendyListId(e.target.value);
                              setSendyVerified(false);
                              setSendyError("");
                              setSendyListName("");
                            }}
                            style={{ flex: 1 }}
                          />
                          <button
                            type="button"
                            className="btn btn-dark"
                            style={{
                              minWidth: "100px",
                              height: "50px",
                              textTransform: "capitalize",
                            }}
                            onClick={verifySendyList}
                            disabled={sendyVerifying || !sendyListId.trim()}
                          >
                            {sendyVerifying ? <Loader size="small" /> : "Verify"}
                          </button>
                        </div>

                        {sendyError && (
                          <span className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                            {sendyError}
                          </span>
                        )}

                        {sendyVerified && sendyListName && (
                          <span className="success-message" style={{ color: "green", fontSize: "12px", marginTop: "5px" }}>
                            List verified: {sendyListName}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <>
                {/* {formValues.isEmail && (
                  <div className="section-details span3">
                    <div className="section-head">
                      <h3>email template</h3>
                    </div>

                    <div className="formInputsGrid threeGridSystem">
                      <div className="formInputBox span3">
                        <label
                          htmlFor="selectedEmailTemplate"
                          className={`formInputLabel`}
                        >
                          template name{" "}
                          <b
                            style={{ cursor: "pointer", fontSize: "30px" }}
                            onClick={() => {
                              const sendableEmailTemplateFilters = {
                                page: 1,
                                limit: 3000,
                                status: "active",
                              };

                              getEmailTemplates(sendableEmailTemplateFilters);
                            }}
                          >
                            ⥁
                          </b>{" "}
                          <span className="required">*</span>
                        </label>

                        <div className="flexBetween">
                          {broadcastTemplatesLoading ? (
                            <Loader />
                          ) : (
                            <div
                              className={`commonWrapper ${
                                formErrors.selectedEmailTemplate
                                  ? "formError"
                                  : ""
                              }`}
                            >
                              <SelectDropdown
                                options={emailTemplates}
                                selectedOption={
                                  formValues.selectedEmailTemplate
                                }
                                setSelectedOption={(selectedValue) =>
                                  onChangeDropdown(
                                    selectedValue,
                                    "selectedEmailTemplate"
                                  )
                                }
                                name="email template"
                              />
                            </div>
                          )}

                          <button
                            type="button"
                            className="btn btn-dark extraBtn"
                            style={{
                              minWidth: "150px",
                              height: "60px",
                              textTransform: "capitalize",
                            }}
                            onClick={() =>
                              setModValues((prevs) => ({
                                ...prevs,
                                isModOpen: true,
                                modName: "add-template",
                              }))
                            }
                          >
                            Create New
                          </button>
                        </div>
                      </div>

                      {formValues.selectedEmailTemplate && (
                        <div className="formInputBox span3">
                          <label htmlFor="body" className="formInputLabel">
                            template body
                          </label>

                          <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border disabled">
                            <ReactQuillTextEditor
                              value={
                                formValues.selectedEmailTemplate?.info?.body ||
                                ""
                              }
                              isError={formErrors?.body}
                              loading={true}
                            />
                          </div>
                        </div>
                      )}

                      {emailVariableKeys.length > 0 && (
                        <div className={`formInputBox span3`}>
                          <div className="flexBetween">
                            <label
                              htmlFor="selectedEmailTemplateVariables"
                              className={`formInputLabel`}
                            >
                              template variables{" "}
                              <span className="required">*</span>
                            </label>

                            <b
                              className="link"
                              style={{ textTransform: "capitalize" }}
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  modName: "add-variable",
                                }))
                              }
                            >
                              create new variable
                            </b>
                          </div>

                          {emailVariableKeys.map((key) => (
                            <div className="variable-key-row" key={key}>
                              <div className="variable-key-label">
                                Key: {key}
                              </div>
                              <div style={{ flex: 1 }}>
                                <SelectDropdown
                                  options={variables}
                                  selectedOption={variables.find(
                                    (v) =>
                                      v.value ===
                                      formValues.selectedEmailTemplateVariables[
                                        key
                                      ]
                                  )}
                                  setSelectedOption={(selectedValue) =>
                                    setFormValues((prev) => ({
                                      ...prev,
                                      selectedEmailTemplateVariables: {
                                        ...prev.selectedEmailTemplateVariables,
                                        [key]: selectedValue.value,
                                      },
                                    }))
                                  }
                                  name={`variable for ${key}`}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )} */}
              </>

              {formValues.isWhatsaap && (
                <div className="section-details span3">
                  <div className="section-head">
                    <h3>whatsapp template</h3>
                  </div>

                  <div className="formInputsGrid threeGridSystem">
                    <div className="formInputBox">
                      <label
                        htmlFor="selectedWhatsappAccount"
                        className={`formInputLabel`}
                      >
                        Wati Account <span className="required">*</span>
                      </label>

                      <div
                        className={`commonWrapper ${
                          formErrors.selectedWhatsappAccount ? "formError" : ""
                        }`}
                      >
                        <SelectDropdown
                          options={wati_accounts}
                          selectedOption={formValues.selectedWhatsappAccount}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown(
                              selectedValue,
                              "selectedWhatsappAccount"
                            )
                          }
                          name="whatsapp account"
                        />
                      </div>
                    </div>

                    {formValues.selectedWhatsappAccount && (
                      <div className="formInputBox span2">
                        <label
                          htmlFor="selectedWPTemplate"
                          className={`formInputLabel`}
                        >
                          template name{" "}
                          <b
                            style={{ cursor: "pointer", fontSize: "30px" }}
                            onClick={() => {
                              if (
                                formValues.selectedWhatsappAccount &&
                                formValues.selectedWhatsappAccount?.value
                              ) {
                                const sendableWPTemplateFilters = {
                                  page: 1,
                                  limit: 3000,
                                  status: "APPROVED",
                                  whatsapp_account:
                                    formValues.selectedWhatsappAccount.value ||
                                    "",
                                };

                                getWPTemplates(sendableWPTemplateFilters);
                              }
                            }}
                          >
                            ⥁
                          </b>{" "}
                          <span className="required">*</span>
                        </label>

                        <div className="flexBetween">
                          {broadcastWPTemplatesLoading ? (
                            <Loader />
                          ) : (
                            <div
                              className={`commonWrapper ${
                                formErrors.selectedWPTemplate ? "formError" : ""
                              }`}
                            >
                              <SelectDropdown
                                options={wpTemplates}
                                selectedOption={formValues.selectedWPTemplate}
                                setSelectedOption={(selectedValue) =>
                                  onChangeDropdown(
                                    selectedValue,
                                    "selectedWPTemplate"
                                  )
                                }
                                name="whatsapp template"
                              />
                            </div>
                          )}

                          <button
                            type="button"
                            className="btn btn-dark extraBtn"
                            style={{
                              minWidth: "150px",
                              height: "60px",
                              textTransform: "capitalize",
                            }}
                            onClick={() =>
                              window.open(
                                "https://live-18717.wati.io/18717/messageTemplate",
                                "_blank"
                              )
                            }
                          >
                            Create New
                          </button>
                        </div>
                      </div>
                    )}

                    {formValues.selectedWPTemplate && (
                      <div className="formInputBox span3">
                        <label htmlFor="body" className="formInputLabel">
                          template body
                        </label>

                        <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border disabled">
                          <ReactQuillTextEditor
                            value={
                              formValues.selectedWPTemplate?.info?.body || ""
                            }
                            isError={formErrors?.body}
                            loading={true}
                          />
                        </div>
                      </div>
                    )}

                    {whatsappVariableKeys.length > 0 && (
                      <div className={`formInputBox span3`}>
                        <div className="flexBetween">
                          <label
                            htmlFor="selectedWPTemplateVariables"
                            className={`formInputLabel`}
                          >
                            template variables{" "}
                            <span className="required">*</span>
                          </label>

                          <b
                            className="link"
                            style={{ textTransform: "capitalize" }}
                            onClick={() =>
                              setModValues((prevs) => ({
                                ...prevs,
                                isModOpen: true,
                                modName: "add-variable",
                              }))
                            }
                          >
                            create new variable
                          </b>
                        </div>

                        {whatsappVariableKeys.map((key) => (
                          <div
                            className={`variable-key-row ${
                              formErrors?.selectedWPTemplateVariables
                                ? "formError"
                                : ""
                            }`}
                            key={key}
                          >
                            <div className="variable-key-label">Key: {key}</div>
                            <div style={{ flex: 1 }}>
                              <SelectDropdown
                                options={variables}
                                selectedOption={
                                  variables.find(
                                    (v) =>
                                      v.value ===
                                      formValues.selectedWPTemplateVariables[
                                        key
                                      ]
                                  ) || null
                                }
                                setSelectedOption={(selectedValue) =>
                                  setFormValues((prev) => ({
                                    ...prev,
                                    selectedWPTemplateVariables: {
                                      ...prev.selectedWPTemplateVariables,
                                      [key]: selectedValue
                                        ? selectedValue.value
                                        : "",
                                    },
                                  }))
                                }
                                name={`variable for ${key}`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {formValues.isPush && (
                <div className="section-details span3">
                  <div className="section-head">
                    <h3>push contents</h3>
                  </div>

                  <div className="formInputsGrid threeGridSystem">
                    <div className="formInputBox span3">
                      <label htmlFor="pushTitle" className={`formInputLabel`}>
                        title <span className="required">*</span>
                      </label>

                      <input
                        type="text"
                        placeholder="Enter push title"
                        className={`formInput ${
                          formErrors?.pushTitle ? "formError" : ""
                        }`}
                        name="pushTitle"
                        value={formValues.pushTitle}
                        onChange={onChangeInput}
                      />
                      <span className="tiny-info-label">
                        ⓘ Make your messages personal using variables like{" "}
                        {"{{1}}"}!
                      </span>
                    </div>

                    <div className="formInputBox span3">
                      <label htmlFor="pushBody" className={`formInputLabel`}>
                        body <span className="required">*</span>
                      </label>

                      <textarea
                        placeholder="Enter push body"
                        className={`formInput ${
                          formErrors.pushBody ? "formError" : ""
                        }`}
                        name="pushBody"
                        value={formValues.pushBody}
                        onChange={onChangeInput}
                      />

                      <span className="tiny-info-label">
                        ⓘ Make your messages personal using variables like{" "}
                        {"{{1}}"}!
                      </span>
                    </div>

                    {pushVariableKeys.length > 0 && (
                      <div className={`formInputBox span3`}>
                        <label className={`formInputLabel`}>
                          Push Variables <span className="required">*</span>
                        </label>
                        {pushVariableKeys.map((key) => (
                          <div
                            className={`variable-key-row ${
                              formErrors?.selectedPushTemplateVariables
                                ? "formError"
                                : ""
                            }`}
                            key={key}
                          >
                            <div className="variable-key-label">Key: {key}</div>
                            <div style={{ flex: 1 }}>
                              <SelectDropdown
                                options={variables}
                                selectedOption={
                                  variables.find(
                                    (v) =>
                                      v.value ===
                                      formValues.selectedPushTemplateVariables[
                                        key
                                      ]
                                  ) || null
                                }
                                setSelectedOption={(selectedValue) =>
                                  setFormValues((prev) => ({
                                    ...prev,
                                    selectedPushTemplateVariables: {
                                      ...prev.selectedPushTemplateVariables,
                                      [key]: selectedValue
                                        ? selectedValue.value
                                        : "",
                                    },
                                  }))
                                }
                                name={`variable for ${key}`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <CloseSubmitBtn
                closeLabel="Back"
                submitLabel={"Next"}
                onClose={handleBack}
                onSubmit={onSumitForm}
                isLoading={postPutLoading}
                isSubmitDisabled={
                  formValues.isEmail &&
                  (formValues.emailProvider === ""
                    ? true
                    : formValues.emailProvider === "sendy"
                    ? !sendyVerified
                    : false)
                }
              />

              {/* <CloseSubmitBtn
            closeLabel="Back"
            submitLabel={"Submit"}
            onClose={handleBack}
            onSubmit={onSumitForm}
            isLoading={postPutLoading}
          /> */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default BroadcastCampaignForm;